import React from "react";
import styles from "./NewsListingCard.module.sass";
import { useNavigate } from "react-router-dom";
export default function NewsListingCard({
  category,
  date,
  title,
  description,
  image,
  url,
}) {
  const navigate = useNavigate();
  const handleNavigation = (path, params = {}) => {
    navigate(path, { state: params });
  };
  return (
    <div
      className={styles.container}
      onClick={() => handleNavigation(`/news/${url || ""}`)}
      style={{ cursor: "pointer" }}
    >
      <div className={styles.left}>
        <img src={image} alt="" />
      </div>
      <div className={styles.right}>
        <div className={styles.categoryContainer}>
          <p>{category}</p>
          <p>{date}</p>
        </div>
        <h2>{title}</h2>
        <p
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        ></p>
      </div>
    </div>
  );
}
